module.exports = __webpack_public_path__ + "static/media/file-integrity-monitoring.8b3e618e.jpg";